<template>
  <div>
    <div class="row">
      <w-select class="col" :model="schema.year" :values="getYears" />

      <template v-if="!!schema.month">
        <w-select class="col" :model="schema.month" :values="months" />
      </template>

      <template v-if="documentDate">
        <w-datepicker class="col" :model="schema.documentDate" />
      </template>
    </div>

    <template v-if="isPersonData">
      <div class="row mt-2">
        <w-input class="col-6" :model="schema.firstName" />

        <w-input class="col-6" :model="schema.lastName" />
      </div>

      <div class="row mt-2">
        <w-input class="col-6" :model="schema.phoneNumber" />

        <w-input class="col-6" :model="schema.email" />
      </div>
    </template>

    <template v-if="isReport">
      <hr />

      <label class="label font-weight-bold"> Przyuczenie do wykonywania określonej pracy </label>

      <div class="row">
        <w-input class="col-6" :model="schema.apprenticeship.numberOfEmployees" />

        <w-datepicker class="col-6" :model="schema.apprenticeship.dateOfReturn" />
      </div>

      <div class="row">
        <w-textarea class="col-12" :model="schema.apprenticeship.reasonOfNotUsingFunds" />
      </div>

      <hr />

      <label class="label font-weight-bold"> Nauka zawodu w okresie kształcenia wynoszącym 36 miesięcy </label>

      <div class="row">
        <w-input class="col-6" :model="schema.learningOfProfession.numberOfEmployees" />

        <w-datepicker class="col-6" :model="schema.learningOfProfession.dateOfReturn" />
      </div>

      <div class="row">
        <w-textarea class="col-12" :model="schema.learningOfProfession.reasonOfNotUsingFunds" />
      </div>
    </template>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { months , getYears } from '@/utils/dates';


// @vuese
// Formularz raportu
// @group ActionData
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true }
  },
  data() {
    return {
      getYears: getYears()
    };
  },
  computed: {
    months() {
      return months(this.schema.year.$model);
    },
    isPersonData() {
      return !!this.schema.firstName && !!this.schema.lastName && !!this.schema.phoneNumber && !!this.schema.email;
    },
    documentDate() {
      return !!this.schema.documentDate;
    },
    isReport() {
      return !!this.schema.apprenticeship && !!this.schema.learningOfProfession;
    }
  }
};
</script>
